import { APP_PATHS } from '@core/constants';
import { MigrationFinding } from '@core/models/migration-report.model';

// The two installation classes that are fixed by choosing channels, which is what the Data
// sources tab does; every other one is read on the General tab.
const DATA_SOURCES_CLASSES: ReadonlySet<string> = new Set([
  'single_role_contested',
  'no_bindable_channel',
]);

// The service page opens only with the service in the store or the navigation state, so a link to
// it by id lands on the services list. The finding's evidence names the location the service
// belongs to, which opens by its id.
function serviceLocationId(finding: MigrationFinding): string | null {
  const { locationId } = finding.evidence;
  return typeof locationId === 'number' || typeof locationId === 'string'
    ? String(locationId)
    : null;
}

// The page that resolves a finding, or null where there is none to send the reader to.
export function findingLink(finding: MigrationFinding): string[] | null {
  const { subjectType, subjectId, findingClass, installationOid } = finding;
  switch (subjectType) {
    case 'location':
      return ['/', APP_PATHS.Locations, subjectId];
    case 'installation':
      return [
        '/',
        APP_PATHS.Installations,
        subjectId,
        DATA_SOURCES_CLASSES.has(findingClass) ? 'data-sources' : 'general',
      ];
    case 'binding':
      return installationOid
        ? ['/', APP_PATHS.Installations, installationOid, 'data-sources']
        : null;
    case 'device':
      return ['/', APP_PATHS.Devices, subjectId, 'general'];
    case 'group':
      return ['/', APP_PATHS.InstallationGroups, subjectId];
    case 'service': {
      const locationId = serviceLocationId(finding);
      return locationId ? ['/', APP_PATHS.Locations, locationId] : null;
    }
  }
}
